import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let userLang = (navigator.language || navigator.userLanguage);
userLang = userLang.toLocaleLowerCase();
let lang = userLang.substring(0, 2).toLowerCase();
let cty = lang;
if (userLang.length>2){
    cty = userLang.substring(3, 5).toLowerCase();    
}

/*alert('lang:'+lang+', cty:'+cty);*/

export default new Vuex.Store({
  state:{
    showKibolt : (lang=='fr' && cty=='fr'),
    lang : 'lang',
    cty : 'cty'
  }
});
